'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import ModalHeader from "../Modal/ModalHeader.js";
var DrawerHeader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ModalHeader, _extends({
    classPrefix: "drawer-header"
  }, props, {
    ref: ref
  }));
});
export default DrawerHeader;